$(document).ready(function () {
  gsap.registerPlugin(ScrollTrigger);
  // Initialize Lenis smooth scrolling
  // const lenis = new Lenis({
  //   duration: 1.1, // Adjust scroll duration
  //   smooth: true, // Enable smooth scroll
  //   direction: "vertical", // Vertical scroll by default
  //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Custom easing
  // });

  // // Animation loop for Lenis
  // function raf(time) {
  //   lenis.raf(time);
  //   requestAnimationFrame(raf);
  // }

  // requestAnimationFrame(raf);

  // // Inform ScrollTrigger about the Lenis scroll
  // lenis.on("scroll", ScrollTrigger.update);

  document.addEventListener("DOMContentLoaded", function () {
    const inputField = document.getElementById("newsletter1");
    const subscribeButton = document.getElementById("subscribeButton");

    inputField.addEventListener("input", function () {
      if (inputField.value.trim() !== "") {
        subscribeButton.classList.remove("invisible");
      } else {
        subscribeButton.classList.add("invisible");
      }
    });
  });

  //parallax accordion slider
  let panels = document.querySelectorAll(".panel");

  panels.forEach((panel) => {
    panel.addEventListener("mouseover", () => {
      removeActiveClasses();
      panel.classList.add("active");
    });

    panel.addEventListener("mouseleave", () => {
      panel.classList.remove("active");
    });
  });

  function removeActiveClasses() {
    panels.forEach((panel) => {
      panel.classList.remove("active");
    });
  }
});

function fadeInFromBelow(selector) {
  const elements = gsap.utils.toArray(selector);

  if (elements.length === 0) return;

  elements.forEach((element) => {
    // Initial state
    gsap.set(element, {
      willChange: "transform, opacity",
      opacity: 0,
      y: 80,
      visibility: "hidden",
    });

    // Create timeline for each element
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top bottom-=70px",
        end: "bottom top+=50px",

        // onEnter: () => tl.play(),
        // onLeaveBack: () => tl.reverse(),
        // toggleActions: "play none none reverse",
        markers: false, // Set to true for debugging
      },
      // paused: true,
    });

    // Animation definition
    tl.to(element, {
      opacity: 1,
      y: 0,
      visibility: "visible",
      duration: 1.3,
      ease: "power4.out",
    });
  });
}

// subscribe cover letter button
document.addEventListener("DOMContentLoaded", function () {
  const inputField = document.querySelector(".newletter_form");
  const subscribeButton = document.getElementById("subscribeButton");
  inputField.addEventListener("input", function () {
    if (inputField.value.trim() !== "") {
      subscribeButton.classList.remove("invisible");
    } else {
      subscribeButton.classList.add("invisible");
    }
  });
});

function heroFadeIn(element) {
  const targets = gsap.utils.toArray(element);

  // Set initial state to autoAlpha: 0 to prevent blinking
  gsap.set(targets, { autoAlpha: 0 });

  targets.forEach((target) => {
    gsap.fromTo(
      target,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 1,
        delay: 0.2,
        scrollTrigger: {
          trigger: target,
          start: "top 100%",

          once: true, // Optional: Makes the animation happen only once
        },
      }
    );
  });
}

function animateYoyo(element) {
  const targets = gsap.utils.toArray(element);

  targets.forEach((target) => {
    gsap.fromTo(
      target,
      {
        y: 20,
      },
      {
        y: 0,
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      }
    );
  });
}
function gallaryScaleIn() {
  const targets = gsap.utils.toArray(".gallery-image img");

  gsap.set(targets, { scale: 0 });

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".image-grid",
      start: "top 80%",
      markers: false,
      toggleActions: "play none none reverse",
    },
  });

  timeline.fromTo(
    targets,
    { scale: 0 },
    {
      scale: 1,
      duration: 1.5,
      ease: "power2.out",
      stagger: {
        from: "center",
        amount: 0.5,
      },
    }
  );
}

/// card staggerring animation
$(document).ready(function () {
  gsap.set(".card-stagger-animation", {
    y: 100,
    opacity: 0,
  });

  gsap.to(".card-stagger-animation", {
    y: 0,
    opacity: 1,
    stagger: 0.3,
    duration: 0.7,
    scrollTrigger: {
      trigger: ".card-stagger-animation",
      start: "top-=25% 80%",
      pin: false,
      markers: false,
      toggleActions: "play none none reverse",
      onEnter: function () {
        // Play animation when entering
        gsap.to(this.trigger, {
          y: 0,
          opacity: 1,
          stagger: 0.3,
          duration: 0.7,
        });
      },
      onLeaveBack: function () {
        // Reverse animation when leaving
        gsap.to(this.trigger, {
          y: 100,
          opacity: 0,
          stagger: 0.3,
          duration: 1.5,
        });
      },
    },
  });
});
//////////////
/// applied on sign-up page
$(document).ready(function () {
  gsap.from(".slideIn_FromLeft", {
    delay: 0.3,
    opacity: 0,
    x: -100,
    duration: 0.7,
  });
  gsap.from(".slideIn_FromRight", {
    delay: 0.3,
    opacity: 0,
    x: 100,
    duration: 0.5,
    stagger: 0.2,
  });
});

// inspiration page animation

function galleryScale_onScroll() {
  const targets = gsap.utils.toArray(".insip-trigger-item img");

  // Set initial scale for all targets
  gsap.set(targets, { scale: 0 });

  targets.forEach((target, index) => {
    gsap.fromTo(
      target,
      { scale: 0.6 },
      {
        scale: 1,
        duration: 1.5,
        ease: "power2.out",
        stagger: {
          amount: 0.5,
        },
        scrollTrigger: {
          trigger: target,
          start: "top 90%",
          markers: false,
          toggleActions: "play none none reverse",
          scrub: false, // Adjust scrub as needed
        },
      }
    );
  });
}

// heading text animation
// function revealTextAnimation(selector) {
//   console.log("revealTextAnimation called for selector:", selector);
//   const elements = document.querySelectorAll(selector);
//   if (elements.length === 0) {
//     console.log("No elements found for selector:", selector);
//     return;
//   }
//   elements.forEach((element) => {
//     // Split the text into lines and characters
//     const split = new SplitType(element, { types: "lines, chars" });
//     // Set initial state
//     gsap.set(split.chars, {
//       scale: 0,
//       willChange: "transform",
//       transformOrigin: "center bottom -20px",
//     });
//     // Create the animation timeline
//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: element,
//         start: "top 80%",
//         end: "bottom 20%",
//         once: true,
//         markers: false,
//       },
//     });
//     // Animate each line
//     split.lines.forEach((line, index) => {
//       const chars = line.querySelectorAll(".char");
//       tl.to(
//         chars,
//         {
//           duration: 1,
//           scale: 1,
//           stagger: {
//             amount: 0.1,
//             from: "center",
//           },
//           ease: "back.out(2)",
//           delay: index * 0.1,
//         },
//         index * 0.1
//       );
//     });
//   });
//   console.log("Animation applied to:", selector);
// }

function revealTextAnimation(selector) {
  console.log("revealTextAnimation called for selector:", selector);
  const elements = document.querySelectorAll(selector);
  if (elements.length === 0) {
    console.log("No elements found for selector:", selector);
    return;
  }
  elements.forEach((element) => {
    // Split the text into lines
    const split = new SplitType(element, { types: "lines" });

    // Set initial state with GPU acceleration
    gsap.set(split.lines, {
      scale: 0,
      willChange: "transform",
      transformOrigin: "center center -20px",
      // Force GPU acceleration
      transform: "translateZ(0)", // or "translate3d(0, 0, 0)"
      rotation: 0.01,
    });

    // Create the animation timeline
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "bottom 20%",
        markers: false,
      },
    });

    // Animate each line
    split.lines.forEach((line, index) => {
      tl.to(
        line,
        {
          rotation: 0.1,
          duration: 1.4,
          scale: 1,
          ease: "back.out(0.5)",
          delay: index * 0.1,
          // Force GPU acceleration
          transform: "translateZ(0)", // or "translate3d(0, 0, 0)"
        },
        index * 0.1
      );
    });
  });
  console.log("Animation applied to:", selector);
}

$(document).ready(function () {
  fadeInFromBelow(".fadeIn-text-animation");
  fadeInFromBelow(".accordion");
  animateYoyo(".image-upDown");
  heroFadeIn(".hideOut-animation");
  revealTextAnimation(".reveal-text-animation");
  gallaryScaleIn();
  galleryScale_onScroll();
});
